'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*------------------------------------*\
    CB Waiting Times Directive
\*------------------------------------*/

/**
  *  Skill codes with relevant skill name
  *
  *  1 : ClaimsVerkeer
  *  2 : ClaimsWoon
  *  3 : ClaimsAVP
  *  4 : ClaimsReis
  *  5 : Sales
  *  6 : SalesBeeindiging
  *  7 : Sparen
  *  8 : DIL
  *  9 : HYP
  * 10 : LevenNieuw
  */

function cbWaitingTimeDirective() {
    return {
        scope: true,
        controller: 'cbWaitingTimeController',
        controllerAs: 'wt'
    };
}

exports.default = cbWaitingTimeDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/waiting-time/cb-waiting-time.directive.js
// module id = 926
// module chunks = 0